function scrollWindowCustom() {
  // homepage header Seach toggle
  if ($("body").length) {
    var scrolltopCustom = $(window).scrollTop();
    if (scrolltopCustom > 0) {
      $(".template-home #header .js__toggle-search").removeClass("shrunk");
      $(".template-product #header .js__toggle-search").removeClass("shrunk");
      $(".template-locations #header .js__toggle-search").removeClass("shrunk");
      $(".template-contact #header .js__toggle-search").removeClass("shrunk");
      $(".template-events #header .js__toggle-search").removeClass("shrunk");
      $(".template-blog #header .js__toggle-search").removeClass("shrunk");
      $(".template-article #header .js__toggle-search").removeClass("shrunk");
      $(".template-account #header .js__toggle-search").removeClass("shrunk");
      $(".template-cart #header .js__toggle-search").removeClass("shrunk");
      $(".template-home #header .js__search-box").addClass("shrunk");
      $(".template-product #header .js__search-box").addClass("shrunk");
      $(".template-locations #header .js__search-box").addClass("shrunk");
      $(".template-contact #header .js__search-box").addClass("shrunk");
      $(".template-events #header .js__search-box").addClass("shrunk");
      $(".template-blog #header .js__search-box").addClass("shrunk");
      $(".template-article #header .js__search-box").addClass("shrunk");
      $(".template-account #header .js__search-box").addClass("shrunk");
      $(".template-cart #header .js__search-box").addClass("shrunk");
      $(".home").addClass("shrunk");
      $(".interior").addClass("shrunk");
    } else {
      $(".template-home #header .js__search-box").removeClass("shrunk");
      $(".template-product #header .js__search-box").removeClass("shrunk");
      $(".template-locations #header .js__search-box").removeClass("shrunk");
      $(".template-contact #header .js__search-box").removeClass("shrunk");
      $(".template-events #header .js__search-box").removeClass("shrunk");
      $(".template-blog #header .js__search-box").removeClass("shrunk");
      $(".template-article #header .js__search-box").removeClass("shrunk");
      $(".template-account #header .js__search-box").removeClass("shrunk");
      $(".template-cart #header .js__search-box").removeClass("shrunk");
      $(".template-home #header .js__toggle-search").addClass("shrunk");
      $(".template-product #header .js__toggle-search").addClass("shrunk");
      $(".template-locations #header .js__toggle-search").addClass("shrunk");
      $(".template-contact #header .js__toggle-search").addClass("shrunk");
      $(".template-events #header .js__toggle-search").addClass("shrunk");
      $(".template-blog #header .js__toggle-search").addClass("shrunk");
      $(".template-article #header .js__toggle-search").addClass("shrunk");
      $(".template-account #header .js__toggle-search").addClass("shrunk");
      $(".template-cart #header .js__toggle-search").addClass("shrunk");
      $(".home").removeClass("shrunk");
      $(".interior").removeClass("shrunk");
    }
  }
}
// homepage header Seach toggle
jQuery(function ($) {
  $(".template-home #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-product #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-locations #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-contact #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-events #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-blog #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-article #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-account #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
  $(".template-cart #header .js__toggle-search").on("click tap", function () {
    $(this).toggleClass("active");
    $("#header .js__search-box").toggleClass("active");
  });
});

// New Arrivals Slider
jQuery(function () {
  /* Slick needs no get Reinitialized on window Resize after it was destroyed */
  $(window).on("load resize orientationchange", function () {
    $(".js__product-slider").each(function () {
      var $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 768) {
        if ($carousel.hasClass("slick-initialized")) {
          $carousel.slick("unslick");
        }
      } else {
        if (!$carousel.hasClass("slick-initialized")) {
          $carousel.slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 500,
            cssEase: "ease-in-out",
            autoplay: false,
            variableWidth: true,
            draggable: true,
            centerMode: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
          });
        }
      }
    });
  });
  $(".js__product-img-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    fade: false,
    asNavFor: ".js__product-img-thumb-slider",
  });
  $(".js__product-img-thumb-slider").slick({
    asNavFor: ".js__product-img-slider",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    variableWidth: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
  });
});
